import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  pageTitle: () => __(translations.familyWebPage.pageTitle, 'Families Web'),
  families: () => __(translations.familyWebPage.families, 'Families Web list'),
  addFamily: () => __(translations.familyWebPage.addFamily, 'Add Family Web'),
  colections: () => __(translations.familyWebPage.colections, 'Colections'),
  name: () => __(translations.familyWebPage.name, 'Name'),
  code: () => __(translations.familyWebPage.code, 'Code'),
  inspiration: () => __(translations.familyWebPage.inspiration, 'Inspiration'),
  createdAt: () => __(translations.familyWebPage.createdAt, 'Created At'),
  edit: () => __(translations.familyWebPage.edit, 'Edit'),
};
